<template>
<div class="mt-3 py-5">
	<b-container class="px-3 p-md-0">
		<b-row>
			<b-col cols="12" md="8" class="m-auto px-3">

        <div class="container">

					<div class="row justify-content-center pt-2 pb-5">

              <nav class="pankuzu w-100">
                <ul class="my-4">
                  <li><img class="" src="/static/img/icon/pankuzu.png" style="height: 17px;padding-bottom: 3px;"><a @click="jump(0)">  ピアチュウ TOP</a></li>
                  <li>  使い方について</li>
                </ul>
              </nav>

              <div class="card">
                <div class="card-header text-center">ピアノを探されているユーザーのガイドライン</div>
                <div class="card-body">
                  <p>ピアチュウを通じて試弾や購入申し込みする場合には、以下のガイドラインを順守ください。以下「ユーザー」とはピアチュウを利用して中古ピアノを探されている方です。「販売事業者」とはピアチュウに登録している中古ピアノ販売事業者を指します。</p>
                  <h2>購入前には試弾をして実際に確かめてください</h2>
                  <p>ユーザーが購入する前には、できる限り試弾をするようにしてください。実際にピアノの置いてある場所に行って現物を確かめます。アナログのピアノは家電製品や電子ピアノと違い、たとえ同じメーカーで同じ型番であっても、音が同じとは限りません。特に中古ピアノの場合は、その後どんな環境に置かれたか、またどんな調整を施したかによって、ずいぶんと違ったものになります。ですから、実際に足を運んでみると、ピアノの状態や音の鳴り、弾き心地がよくわかり、選びやすくなります。それと同時に販売事業者の人となりがよくわかるので、納品後のケアも含めて安心して取引できるかどうかの判断材料にもなります。</p>
                  <h2>試弾の約束はしっかり守ってください</h2>
                  <p>ユーザーが試弾を希望した場合、販売事業者とメッセージ等でやり取りをして、約束した日時を守るようにしてください。　販売事業者も時間をとって待っているので、連絡なくキャンセルすることはやめてください。その他当日のキャンセルなど誠意のない行為を繰り返された場合、サイトの利用停止となる場合があります。</p>
                  <h2>試弾の際に販売事業者から説明を受けた上で、購入を慎重に検討してください</h2>
                  <p>ピアノは高価なものですから、後々後悔のないようじっくり検討ください。一台だけでなく、できれば数台は試弾して比較検討してみてください。そのほうがよりふさわしいピアノを選ぶことができるでしょう。また、ピアノには必ず運送費が必要になります。購入の前には、ピアノ本体の代金だけでなく、付属品に費用はかかるのか、運送費はどれくらいかかりそうかなど予め確かめておく必要があります。尚、ピアチュウは信頼できるピアノ販売事業者に限って登録してもらうことを務めていますが、ユーザーと販売事業者の間に生じたトラブルには一切の責任を負いかねます。
                    <br>
                  </p>
                  <h2>試弾申込み後について</h2>
                  <p>サイトから試弾申し込みを行い、実際にそれを弾いてみた後に購入を決めた場合は、サイト上よりその商品の購入申込みを必ず行ってください。もしこの購入手続きがなされない時は、サイトの利用停止となる場合があります。
                    <br>
                    <br>また試弾の際に、試弾申し込みをした商品以外を提案され、それを購入したい場合は、その新たな商品のページをピアチュウ上で販売業者に提示してもらうか、新たに作成してもらい、そこから購入申し込みを行うようにしてください。もしこの手続きがなされない時は、同様にサイトでの利用停止となる場合があります。
                  </p>
                  <p>※ピアチュウで禁止されている行為について詳しくは、 <strong><a href="https://www.piachu.net/prohibited_acts">こちら</a></strong>を御覧ください。 
                  </p>
                  <h2>キャンセル、返金について</h2>
                  <p>サイト上での購入申込み後、キャンセルを行う場合は、必ず以下の手続きに沿ってキャンセルの連絡をしてください。もしガイドラインに沿ったキャンセル手続きがなされない時は、サイトでの利用停止となる場合があります。</p>
                  <p>ユーザーがサイト上から購入申し込み後、なんらかの事情により万が一キャンセルする場合は、次の手続きに従ってください。&nbsp;</p>
                  <p>
                    <strong>・サイト・ログイン画面内のメッセージ（チャット）機能を使い、キャンセル先の販売事業者へその旨を連絡して同意を得る</strong>
                  </p>
                  <p>尚、販売事業者に代金を支払った後及びピアノ納品後のキャンセルについては、ピアチュウはいっさい介入せず、その責任と返金の義務を負わないものとします。その場合は、その販売事業者との契約に基づき、その販売事業者と個別に返金等の相談をしてください。</p>
                  <br>
                  <br>
                  <p>上記にかかわらず、ピアチュウに相応しくない行為があったとみなされた場合には、運営事務局の判断により、以降の利用停止の措置を行う可能性があります。</p>
                  <p>尚、ピアチュウで禁止されている行為について詳しくは、<a href="https://www.piachu.net/prohibited_acts"> 
                    <strong>こちら</strong></a>を御覧ください。 </p>
                </div>
              </div>

					</div>

        </div>

			</b-col>
		</b-row>
	</b-container>
</div>
</template>

<script>
import { mapActions, mapState } from 'vuex';

export default {
  name: 'GuidelineUser',
  data() {
    return {
    }
  },
  methods: {
    jump(number) {
      if (number==0) {
        this.$router.push({path: '/'});
      }
    },
  },
	computed: {
	},
  created() {
  },
}
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/GuidelineUser.vue